import type { WorkflowRule } from '@/pages/ats-job-creation/tabs/interview-plan/stage/automation/api/workflowRule.types';

// Display label for a rule's automation in the move modal + underway
// popup. The popup reads "<label> starting soon…", which refers to the
// next action that fires — so use the first action's own label
// ("Send email", "Send review"), not the rule's generated name
// (`Stage automation: <stage>`), which would surface as noise in the
// header. Multi-action rules still lead with the first action, since
// that's the one starting soon; the rest are chained behind it.
export const getActivityLabel = (
  rule: WorkflowRule | null | undefined
): string => {
  const actions = rule?.actions ?? [];
  const first =
    [...actions].sort((a, b) => (a.position ?? 0) - (b.position ?? 0))[0]
      ?.target ?? actions[0]?.target;
  return first?.label ?? first?.kind ?? 'Stage activity';
};
